export default __webpack_public_path__ + "static/media/AirCargo1.d0ca3b53.png";